import { Box, Grid } from "@mui/material";
import { FormDataType } from "DataTypes/Form";
import { CreateCaseModalType } from "DataTypes/Modal.type";
import { FC } from "react";
import { commonFormSwitch, ControlledBoxSizeSwitch } from "Utils/SwitchCases";

const createCaseModal: FC<CreateCaseModalType> = (props) => {
  const { formArr, handleChange } = props;
  return (
    <Box component="form" sx={{ mt: 1 }}>
      <Grid mb={2} container columnSpacing={2} rowSpacing={2}>
        {formArr.map((el: FormDataType) => (
          <Grid key={el.id} size={{ ...ControlledBoxSizeSwitch(el.boxSize) }}>
            {commonFormSwitch({
              formObj: el,
              onChange: (data) => handleChange(data, formArr),
            })}
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default createCaseModal;
